import angular from 'angular';

import { drawerDirective } from './drawer.directive';

import './drawer.scss';

export default angular
  .module('ui.drawer', [])
  .directive('drawer', drawerDirective);
